import { Divider, Flex, FlexProps, Icon, Text, TypeColors } from '@bitrise/bitkit';
import { TypeAttribute } from '@trace/types';
import React, { FunctionComponent } from 'react';
import { ATTRIBUTE_ICON_MAP, ATTRIBUTE_NAME_MAP } from '../../constants/Attributes';
import getFormattedAttributeValue from '../../utils/getFormattedAttributeValue';

interface Props extends FlexProps {
  attribute: TypeAttribute | string;
  backgroundColor?: TypeColors;
  title?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value?: any;
  withIcon?: boolean;
}

const AttributeStat: FunctionComponent<Props> = ({
  attribute,
  children,
  title,
  value,
  withIcon,
  ...rest
}) => {
  const attributeIcon = ATTRIBUTE_ICON_MAP[attribute as TypeAttribute];
  const attributeName = ATTRIBUTE_NAME_MAP[attribute as TypeAttribute];

  return (
    <Flex {...rest} direction="vertical" gap="x2">
      <Flex grow>
        <Flex alignChildrenVertical="middle" direction="horizontal" gap="x2" margin="x1">
          {withIcon && attributeIcon && (
            <Flex>
              <Icon name={attributeIcon} />
            </Flex>
          )}

          <Flex grow initial="none">
            <Text ellipsis size="x2" weight="bold">
              {title || attributeName || attribute}
            </Text>
          </Flex>
        </Flex>

        <Text config="8" textColor="gray-7">
          {children || getFormattedAttributeValue(attribute as TypeAttribute, value)}
        </Text>
      </Flex>

      <Flex>
        <Divider color="gray-2" width="0.0625rem" />
      </Flex>
    </Flex>
  );
};

export default AttributeStat;
